import type { Post } from '@getaccept/dsr-shared-new';
import type { LoadPostsPayload } from '@getaccept/dsr-shared-new/src/types/post';
import { GraphQLFetchPolicy } from '@getaccept/lib-shared-new/src/graphql/graphql-fetch-policy';
import { apolloClient } from '../../apollo';
import { PostQueries } from './graphql/post.queries';
import { PostMutations } from './graphql/post.mutations';

export class PostService {
  static async load({
    offset,
    limit,
    sortBy,
    sortOrder,
  }: Partial<LoadPostsPayload>): Promise<Post[]> {
    const {
      data: { getPosts },
    } = await apolloClient.query({
      query: PostQueries.load,
      variables: { offset, limit, sortBy, sortOrder },
      fetchPolicy: GraphQLFetchPolicy.NetworkOnly,
    });
    return getPosts;
  }

  static async setSeenBy(postId: string): Promise<boolean> {
    const { data } = await apolloClient.mutate({
      mutation: PostMutations.setSeenBy,
      variables: { postId },
    });

    return !!data;
  }
}
